function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { PureComponent } from "react";
import { Menu, Button, Space, Tag, Dropdown, Popover } from 'antd';
import SingleFilterPanel from './SingleFilterPanel';
import { oDataDataSource } from "../datasources/ODataDataSource";
import { localeText } from './locale/en';
import { defaultFilterTypes } from './Filters/defaultFilterTypes';

const merge = require('deepmerge');

export default class FilterPanel extends PureComponent {
  constructor(_props) {
    super(_props);

    this.getFilterDef = name => {
      return this.props.filterDefs.filter(fd => fd.name === name)[0];
    };

    this.getFullFilterDefByDef = filterDef => {
      if (!filterDef) return undefined;
      let dataSource = {};

      if (filterDef.dataSource && this.props.dataSources) {
        dataSource = filterDef.dataSource.name ? this.props.dataSources[filterDef.dataSource.name] : this.props.dataSources[Object.keys(this.props.dataSources)[0]];
        dataSource = merge.all([defaultFilterTypes[filterDef.type] ? defaultFilterTypes[filterDef.type].dataSources[dataSource.type] || {} : {}, this.props.filterTypes && this.props.filterTypes[filterDef.type] ? this.props.filterTypes[filterDef.type].dataSources[dataSource.type] || {} : {}, this.dataSourceTypes[dataSource.type], dataSource]);
      }

      return merge.all([defaultFilterTypes[filterDef.type] || {}, this.props.filterTypes && this.props.filterTypes[filterDef.type] || {}, {
        dataSource: dataSource
      }, filterDef || {}]);
    };

    this.getFullFilterDefByName = name => {
      return this.getFullFilterDefByDef(this.getFilterDef(name));
    };

    this.getFullFilterDefs = () => {
      return this.props.filterDefs.map(filterDef => this.getFullFilterDefByDef(filterDef));
    };

    this.getFilters = () => {
      return this.state.filterValues;
    };

    this.getSingleFilterPanel = ({
      filterDef,
      isNew
    }) => {
      if (!filterDef) return null;
      let name = filterDef.name; //let key = `${filterDef.name}${isNew ? '_new' : ''}`;

      let key = isNew ? '_new' : filterDef.name;
      let value = this.state.filterValues[name];
      let valueProps = this.state.filterValueProps[name];
      return /*#__PURE__*/React.createElement(SingleFilterPanel, _extends({}, filterDef, {
        api: this,
        filters: this.state.filterValues,
        value: value,
        valueProps: valueProps,
        localeText: this.localeText,
        onOk: this.singleFilterPanelOnOk,
        onCancel: this.singleFilterPanelOnCancel,
        visible: this.state.filterPanelVisibleKey === key,
        key: key
      }));
    };

    this.renderFilters = () => {
      if (!this.state.filterValues) return null;
      return Object.keys(this.state.filterValues).map(name => {
        let value = this.state.filterValues[name];
        let valueProps = this.state.filterValueProps[name];
        let filterDef = this.getFullFilterDefByName(name);
        if (!filterDef || !this.state.filterValues[name]) return null;
        let templateFunc = filterDef.template;
        let template = templateFunc({
          filterDef,
          value,
          valueProps: valueProps,
          localeText: this.localeText
        });
        return /*#__PURE__*/React.createElement(Popover, {
          trigger: "click",
          onVisibleChange: () => this.setState({
            filterPanelVisibleKey: this.state.filterPanelVisibleKey === name ? undefined : name
          }),
          visible: this.state.filterPanelVisibleKey === name,
          key: name,
          overlayStyle: {
            width: '298px'
          },
          title: filterDef.title,
          placement: "bottomLeft",
          content: this.getSingleFilterPanel({
            filterDef
          })
        }, /*#__PURE__*/React.createElement(Tag, {
          key: name,
          closable: true,
          onClose: () => this.updateFilter({
            filterDef: filterDef,
            value: null
          }),
          onClick: () => this.setState({
            currentFilterPanel: name
          })
        }, template));
      });
    };

    this.renderFilterList = () => {
      return this.props.filterDefs.map(filterDef => {
        return /*#__PURE__*/React.createElement(Menu.Item, {
          key: filterDef.name,
          onClick: () => this.setState({
            filterPanelVisibleKey: "_new",
            newFilterDef: this.getFullFilterDefByDef(filterDef)
          })
        }, filterDef.title);
      });
    };

    this.singleFilterPanelOnCancel = () => {
      this.setState({
        filterPanelVisibleKey: undefined
      });
    };

    this.singleFilterPanelOnOk = props => {
      this.setState({
        filterPanelVisibleKey: undefined
      });
      this.updateFilter(props);
    };

    this.updateFilter = props => {
      let {
        filterDef,
        value,
        valueProps
      } = props;
      this.setState({
        filterValues: { ...this.state.filterValues,
          [filterDef.name]: value
        },
        filterValueProps: { ...this.state.filterValueProps,
          [filterDef.name]: valueProps
        }
      }, () => {
        if (this.onChangeEvent) {
          this.onChangeEvent({
            api: this,
            filterDef: filterDef,
            value: value,
            filters: this.state.filterValues
          });
        }
      });
    };

    this.clearAllFilters = () => {
      this.setState({
        filterValues: [],
        filterValueProps: []
      }, () => {
        if (this.onChangeEvent) {
          this.onChangeEvent({
            api: this,
            filters: this.state.filterValues
          });
        }
      });
    };

    this.initSingleFilterValueProps = props => {
      let {
        filterDef,
        valueProps
      } = props;
      let name = filterDef.name;
      this.setState({
        filterValueProps: { ...this.state.filterValueProps,
          [name]: valueProps
        }
      });
    };

    this.initFilterValueProps = props => {
      let {
        filters
      } = props;
      let filterDefs = this.getFullFilterDefs();

      for (let filterDef of filterDefs) {
        let name = filterDef.name;
        let value = filters[name];

        if (value === undefined || value === null || !filterDef.dataSource.init) {
          this.initSingleFilterValueProps({
            filterDef: filterDef,
            valueProps: undefined
          });
        } else {
          filterDef.dataSource.init({
            filterDef: filterDef,
            value: value,
            callback: valueProps => this.initSingleFilterValueProps({
              filterDef: filterDef,
              valueProps: valueProps
            })
          });
        }
      }
    };

    this.setFilters = props => {
      let {
        filters
      } = props;
      this.initFilterValueProps({
        filters
      });
      this.setState({
        filterValues: filters
      });
    };

    this.dataSourceTypes = {
      odata: {
        instance: oDataDataSource
      }
    };
    this.state = {
      newFilterDef: null,
      filterValues: [],
      filterValueProps: [],
      filterPanelVisibleKey: undefined
    };
    this.localeText = _props.localeText || localeText;
    this.onChangeEvent = this.props.onChange;
  }

  componentDidMount() {
    if (this.props.onReady) this.props.onReady({
      api: this
    });
  }

  componentDidUpdate() {}

  render() {
    return /*#__PURE__*/React.createElement(Space, {
      size: "small"
    }, this.renderFilters(), /*#__PURE__*/React.createElement(Dropdown, {
      placement: "bottomRight",
      overlay: /*#__PURE__*/React.createElement(Menu, null, this.renderFilterList(), /*#__PURE__*/React.createElement(Menu.Item, {
        onClick: this.clearAllFilters,
        style: {
          fontWeight: 'bold'
        }
      }, this.localeText.ClearAllFilterButton))
    }, /*#__PURE__*/React.createElement(Popover, {
      overlayStyle: {
        width: '398px'
      },
      title: this.state.newFilterDef ? this.state.newFilterDef.title : undefined,
      placement: "bottomLeft",
      content: this.getSingleFilterPanel({
        filterDef: this.state.newFilterDef,
        isNew: true
      }),
      visible: this.state.filterPanelVisibleKey === "_new"
    }, /*#__PURE__*/React.createElement(Button, {
      type: "link"
    }, this.localeText.AddFilterButton))));
  }

}